"use strict";
exports.__esModule = true;
exports.getAttributeColorAssignment = exports.isValidMappedColor = exports.ColorStrategy = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var color_1 = require("./color");
var uniqBy_1 = tslib_1.__importDefault(require("lodash/uniqBy"));
/**
 * @internal
 */
var ColorStrategy = /** @class */ (function () {
    function ColorStrategy(colorPalette, colorMapping, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    viewByAttribute, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    stackByAttribute, dv, theme) {
        this.theme = theme;
        var _a = this.createColorAssignment(colorPalette, colorMapping, viewByAttribute, stackByAttribute, dv), fullColorAssignment = _a.fullColorAssignment, outputColorAssignment = _a.outputColorAssignment;
        this.fullColorAssignment = fullColorAssignment;
        this.outputColorAssignment = outputColorAssignment ? outputColorAssignment : fullColorAssignment;
        this.palette = this.createPalette(colorPalette, this.fullColorAssignment, viewByAttribute, stackByAttribute);
    }
    ColorStrategy.prototype.getColorByIndex = function (index) {
        return this.palette[index];
    };
    ColorStrategy.prototype.getColorAssignment = function () {
        return this.outputColorAssignment;
    };
    ColorStrategy.prototype.getFullColorAssignment = function () {
        return this.fullColorAssignment;
    };
    ColorStrategy.prototype.createPalette = function (colorPalette, colorAssignment, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    _viewByAttribute, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    _stackByAttribute) {
        return colorAssignment.map(function (map, index) {
            var color = sdk_model_1.isColorFromPalette(map.color)
                ? color_1.getColorByGuid(colorPalette, map.color.value, index)
                : map.color.value;
            return color_1.getRgbStringFromRGB(color);
        });
    };
    return ColorStrategy;
}());
exports.ColorStrategy = ColorStrategy;
//
// These functions are often used when constructing custom strategies
//
/**
 * @internal
 */
function isValidMappedColor(colorItem, colorPalette) {
    if (!colorItem) {
        return false;
    }
    if (colorItem.type === "guid") {
        return isColorItemInPalette(colorItem, colorPalette);
    }
    return true;
}
exports.isValidMappedColor = isValidMappedColor;
/**
 * @internal
 */
function isColorItemInPalette(colorItem, colorPalette) {
    return colorPalette.some(function (paletteItem) {
        return colorItem.type === "guid" && colorItem.value === paletteItem.guid;
    });
}
/**
 * @internal
 */
function getAttributeColorAssignment(
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
attribute, colorPalette, colorMapping, dv) {
    var currentColorPaletteIndex = 0;
    var uniqItems = uniqBy_1["default"](attribute.items, "attributeHeaderItem.uri");
    return uniqItems.map(function (headerItem) {
        var mappedColor = color_1.getColorFromMapping(headerItem, colorMapping, dv);
        var color = mappedColor && isValidMappedColor(mappedColor, colorPalette)
            ? mappedColor
            : {
                type: "guid",
                value: colorPalette[currentColorPaletteIndex % colorPalette.length].guid
            };
        currentColorPaletteIndex++;
        return {
            headerItem: headerItem,
            color: color
        };
    });
}
exports.getAttributeColorAssignment = getAttributeColorAssignment;
//# sourceMappingURL=base.js.map